import { createContext, useState, useEffect } from "react";
import LanguageJson from "./language.json"

const VernacularContext = createContext();

const LanguageProvider = ({ children }) => {
    console.log("LanguageProvider called",sessionStorage.getItem("selectedLanguage"));
    const [language, setLanguage] = useState(window.sessionStorage.getItem("selectedLanguage"));

    // sessionStorage.setItem("language", language);



    useEffect(() => {
        // document.body.className = theme;

        console.log("LanguageContext language useEffect called", language);
        console.log("sessionStorage language", sessionStorage.getItem("language"));

        const storedLanguage = sessionStorage.getItem("language");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        } else{
            setLanguage("en");
        }
    }, []);

    const getTransalatedKey = (val) => {

        console.log()

        let valLower = val.toLowerCase();

        // console.log("language", language);
        // console.log("val", val);    
        // console.log("LanguageJson", LanguageJson);
        // console.log("LanguageJson[language]", LanguageJson[language]);
        // console.log("LanguageJson[language][val]", LanguageJson[language ? language : "en"][valLower]);

        if (LanguageJson[language] && LanguageJson[language][valLower]) {
            return LanguageJson[language][valLower];
        }

        // return LanguageJson[language]["welcome"];

    };

    return (

        <VernacularContext.Provider value={{ language, getTransalatedKey }}>

            {children}
        </VernacularContext.Provider>
    );
};

export { VernacularContext, LanguageProvider };

